// extracted by mini-css-extract-plugin
export default {"header":"SharingHeader_header__laAM+"};